import { render, staticRenderFns } from "./DictsListRow.vue?vue&type=template&id=c28db380"
import script from "./DictsListRow.vue?vue&type=script&lang=js"
export * from "./DictsListRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports